















































import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import {prefixPublicAsset} from '@/common/plugins/public-asset-plugin';

export default {
  name: 'Question496',
  components: {
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        positiveFormalCharge: [],
        language: 'fr',
      },
      options: [
        {text: 'Molécule A', value: 'A'},
        {text: 'Molécule B', value: 'B'},
        {text: 'Molécule C', value: 'C'},
      ],
    };
  },
  computed: {
    imageName(): string {
      return prefixPublicAsset('/img/assignments/formalChargeAssessment.png');
    },
  },
};
